<button
	class="w-full h-full py-2 font-medium border-[0.5px] active:border duration-300 gap-1 rounded-md flex justify-start items-center text-gray-500 outline-none focus-visible:ring-2 focus-visible:ring-offset-4 focus-visible:ring-green-light"
	[ngClass]="classes()"
	(click)="clicked.emit($event)"
	(dragstart)="dragstart.emit($event)"
	(dragend)="dragend.emit($event)"
	[ariaLabel]="ariaLabel()"
	[draggable]="draggable()"
	[disabled]="disabled()"
>
	<i-tabler
		data-testid="block-button-icon"
		*ngIf="iconName() as iconName"
		[ngClass]="iconClasses()"
		[name]="iconName"
	/>
	<span class="truncate">
		{{ label() }}
	</span>
</button>
